import type { ApiClient } from '@travel/api-client';
import env from '@travel/env';

import { isServer } from 'core/httpClient';

import type { Banners } from 'Banner-Types';
export const fetch = async (http: ApiClient): Promise<Banners> => {
  const url = isServer
    ? env('UNIVERSAL_BANNER_API_SERVER_URL')
    : env('UNIVERSAL_BANNER_API_CLIENT_URL');

  return http.get(url as string, {
    ignoreCommonErrorHandler: true,
    isThirdPartyApi: true,
  });
};
